import { CONSENT_POLICY_GRANULAR_OPTIN, ConsentPolicy, IConsent } from "types/consent";

import { IConfigFileScript } from "types/config-files/mainConfig";
import { NECESSARY } from "constants/categories";
import { TRUE } from "constants/primitives";
import includes from "helpers/includes";

const isServiceAccepted = (
  service: IConfigFileScript,
  consent: IConsent,
  consentPolicy: ConsentPolicy
): boolean => {
  const { consent_key, categories } = service;
  if (includes(categories, NECESSARY)) {
    return TRUE;
  }

  if (consentPolicy === CONSENT_POLICY_GRANULAR_OPTIN) {
    return !!consent[consent_key];
  } else {
    return categories.every((cat) => !!consent[cat]);
  }
};

export default isServiceAccepted;
